import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminProtected from './admin/AdminProtected';
import AdminToday from './admin/AdminToday';
import AdminNumbers from './admin/AdminNumbers';
import AdminContent from './admin/AdminContent';
import AdminKnowledge from './admin/AdminKnowledge';
import AdminSettings from './admin/AdminSettings';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route element={<AdminProtected />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminToday />} />
            <Route path="/admin/numbers" element={<AdminNumbers />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/knowledge" element={<AdminKnowledge />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
